import { useCallback, useReducer } from "react";
const initialState = {
    chain: "signer",
    signatureIndex: undefined,
    counterSignatureIndex: undefined,
    danglingCertificateIndex: undefined,
    certificateId: undefined,
};
const reducer = (state, action) => {
    switch (action.type) {
        case "SELECT_SIGNATURE":
            return {
                danglingCertificateIndex: undefined,
                certificateId: action.payload.certificateId,
                signatureIndex: action.payload.index,
                counterSignatureIndex: undefined,
                chain: "signer",
            };
        case "SELECT_DANGLING_CERTIFICATE":
            return {
                signatureIndex: undefined,
                certificateId: action.payload.certificateId,
                danglingCertificateIndex: action.payload.index,
                counterSignatureIndex: undefined,
                chain: "signer",
            };
        case "SELECT_CERTIFICATE":
            return {
                ...state,
                counterSignatureIndex: action.payload.chain === "counter-signer"
                    ? action.payload.counterSignatureIndex
                    : undefined,
                chain: action.payload.chain,
                certificateId: action.payload.certificateId,
            };
        default:
            return state;
    }
};
export const useSignature = () => {
    const [signatureState, dispatch] = useReducer(reducer, initialState);
    const handleSelectSignature = useCallback((index, certificateId) => {
        dispatch({
            type: "SELECT_SIGNATURE",
            payload: { index, certificateId },
        });
    }, []);
    const handleSelectDanglingCertificate = useCallback((index, certificateId) => {
        dispatch({
            type: "SELECT_DANGLING_CERTIFICATE",
            payload: { index, certificateId },
        });
    }, []);
    const handleSelectCertificate = useCallback((certificateId, chain, counterSignatureIndex) => {
        dispatch({
            type: "SELECT_CERTIFICATE",
            payload: { certificateId, chain, counterSignatureIndex },
        });
    }, []);
    return {
        signatureState,
        handleSelectSignature,
        handleSelectDanglingCertificate,
        handleSelectCertificate,
    };
};
export default useSignature;
//# sourceMappingURL=useSignature.js.map